import { settingsConditions } from './conditions'
import { settingsScenarios } from './steps'
import { settingsTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const settingsOnboarding: IOnboardingModule = {
  scenarios: settingsScenarios,
  texts: settingsTexts,
  conditions: settingsConditions,
}
